import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  backgroundColor: (p) => p.palette.common.white,
};
